// @ts-nocheck
import styled from 'styled-components';
import { getTheme } from 'settings/theme';
import { TABLET_SMALLER_WIDTH } from 'commons/constants/size';
import SearchInput from 'components/SearchInput';
import type { StatelessFunctionalComponent } from 'react';
import Lottie from 'react-lottie';

const {
  palette: { primary, neutral, noodle, greyscale },
  spacing,
  fontTypes,
  underlineLink,
  noodera: { spacing: nooderaSpacing, fontTypes: nooderaFontType },
} = getTheme();
const GlobalSearchWrapper: StatelessFunctionalComponent<any> = styled.div`
  background-color: ${greyscale.white};
  margin-bottom: 1rem;
  display: flex;
  justify-content: center;
  padding-left: ${spacing.x4};
  padding-right: ${spacing.x4};
  padding-top: ${spacing.x4};
  min-height: calc(100vh - 4.2rem);

  .global-search {
    &__results-title {
      ${fontTypes.font3};
      font-weight: 700;
      margin-bottom: ${spacing.x3};
    }

    &__results-loader {
      height: 3rem;
      margin-bottom: ${spacing.x3};
    }

    &__search-something {
      &__text {
        margin-top: ${spacing.x5};
        text-align: center;
        ${fontTypes.font4};
      }
    }

    &__cards {
      & > div {
        margin-bottom: ${spacing.x4};
      }
    }

    &__back-btn {
      margin: ${spacing.x4} 0 ${spacing.x4};

      & button {
        padding: 0 !important;
      }
    }

    &__filter {
      margin-bottom: ${spacing.x3};

      &::-webkit-scrollbar {
        display: none;
      }

      & > button {
        margin-right: ${spacing.x6};
      }
    }

    &__container {
      max-width: 95.2rem;
      flex: 1;
      width: 100%;
      position: relative;
    }

    &__nav {
      display: flex;
      flex: 1;
      &__select {
        display: none;
      }
    }
    &__not-found {
      align-items: center;
      display: flex;
      height: 50vh;
      justify-content: center;
      flex-direction: column;

      &__title {
        ${fontTypes.font3};
        font-weight: 700;
        margin-bottom: ${spacing.x3};
      }

      &__icon-section {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        & > i {
          font-size: 6rem;
        }

        & > p {
          ${fontTypes.font4};
          margin-top: ${spacing.x4};
        }
      }
    }

    &__text {
      text-align: center;
    }
  }

  @media only screen and (max-width: ${TABLET_SMALLER_WIDTH}px) {
    margin-top: 0;
    padding: 0;

    .global-search {
      &__inner-container {
        padding-left: ${spacing.x4};
        padding-right: ${spacing.x4};
      }

      &__search-something {
        margin-top: ${spacing.x1};
      }

      &__bar {
        position: sticky;
        top: 0;
        display: flex;
        align-items: center;
        min-height: ${nooderaSpacing.x2};
        padding: 0 ${nooderaSpacing.x9} 0 ${nooderaSpacing.x6};
        background-color: ${primary.hundred};
        z-index: 3;

        & > div {
          flex: 1;
          > div {
            height: ${nooderaSpacing.x3};
            border: 1px solid ${greyscale.white};
            border-radius: ${nooderaSpacing.x7};
            background: ${primary.hundredTwenty};
          }
        }

        .global-search__back {
          padding-left: 0;
          background: transparent;
          border: none;
        }

        .sb__wrapper_left {
          input {
            background: transparent;
            color: ${primary.ten};

            ::placeholder {
              color: ${greyscale.white};
            }
          }
        }

        .sb__wrapper_right svg path {
          fill: ${greyscale.white};
        }

        .sb__search-btn,
        .sb__close-btn {
          background: transparent;
          border: none;
          margin-right: ${nooderaSpacing.x7};
        }

        &__cancel {
          ${fontTypes.font5};
          margin-left: ${spacing.x4};
          border: none;
          color: ${noodle.primary};
          background: ${greyscale.white};
        }
      }

      &__filter {
        overflow-y: hidden;
        max-height: 4.3rem;
        min-height: 4.3rem;
        white-space: nowrap;
        max-width: 100%;
      }

      &__container {
        border-radius: 0;
        min-height: 100vh;
      }

      &__nav {
        display: none;
      }
    }
  }
`;
export default GlobalSearchWrapper;
export const StyledSearch: StatelessFunctionalComponent<any> = styled(SearchInput)`
  margin-top: ${spacing.x4};
  margin-bottom: ${({ withResults }) => (withResults ? 0 : spacing.x1)};
`;
export const Header: StatelessFunctionalComponent<any> = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 56px;
  background: ${greyscale.white};
  border-bottom: 1px solid ${neutral.twenty};
`;
export const StyledLinkButton: StatelessFunctionalComponent<any> = styled.span`
  ${nooderaFontType.font5Medium};
  ${underlineLink};
`;
export const StyledParagraph: StatelessFunctionalComponent<any> = styled.p`
  ${nooderaFontType.font4};
  color: ${neutral.hundred};
  text-align: center;
  margin-top: ${nooderaSpacing.x6};
`;
export const StyledLottie: StatelessFunctionalComponent<any> = styled(Lottie)`
  transform: rotate(-20deg);
  max-width: 360px;
  max-height: 240px;
`;
export const StyledTitle: StatelessFunctionalComponent<any> = styled.h1`
  ${nooderaFontType.font2Medium};
  margin: ${spacing.x4} 0;
`;
export const StyledSubTitle: StatelessFunctionalComponent<any> = styled.h2`
  ${nooderaFontType.font5Medium};
  margin: ${spacing.x4} 0;
`;
